import { FormProvider } from 'react-hook-form';
import { useDeleteClientDialog } from './hooks';
import { DeleteClientDialogPresentation } from './presentations';

type Props = {
  /**
   * ダイアログを閉じるコールバック（親 Container から受け取る）
   */
  onClose: () => void;
  /** 利用企業名 */
  name: string;
  /** 取引店舗名（未設定の場合は '-'） */
  partnerBranchName: string;
  /** 担当者名（未設定の場合は '-'） */
  contactPersonName: string;
  /** 契約プラン名（未設定の場合は '-'） */
  contractPlanName: string;
  /** 利用者数 */
  userCount: number;
  /**
   * 削除対象の利用企業 ID
   */
  clientId: string;
  /**
   * マスタ取引店舗一覧（GET /api/v1/{threeLetterCode}/partner_admins/partner_branches）に
   * 1件以上の取引店舗が存在するか（PEN-985）
   *
   * true のときのみ表示情報の「取引店舗」項目を表示する。親 Container（ClientList）から
   * 受け取る（一覧テーブルの取引店舗列と出し分けを一致させるため。PEN-989）。
   */
  hasPartnerBranch: boolean;
  /**
   * 削除成功後コールバック
   *
   * 親 Container（ClientList）から受け取り、一覧再フェッチ・未与信カウント再取得を行う
   */
  onDelete: () => void;
};

/**
 * 利用企業削除ダイアログ Container
 *
 * - 開閉状態は親 Container（ClientList）の Component Hook で管理する
 * - 削除対象の表示情報（5項目）を親 Container から受け取り、Presentation に渡す（PEN-715 T07d）
 * - T07e（PEN-743）: 共通フォーム化（discriminated union 廃止）
 * - T08（PEN-699）: バリデーション・エラー表示・DELETE API 送信・Toast・削除ボタン活性制御
 * - hasPartnerBranch のときのみ表示情報の「取引店舗」項目を表示する（PEN-985 / PEN-989）
 */
export const DeleteClientDialog: React.FC<Props> = ({
  onClose,
  name,
  partnerBranchName,
  contactPersonName,
  contractPlanName,
  userCount,
  clientId,
  hasPartnerBranch,
  onDelete,
}) => {
  const {
    state: { methods, isSubmitEnabled },
    actions: { handleClose, handleSubmit },
  } = useDeleteClientDialog({ onClose, name, clientId, onDelete });

  return (
    <FormProvider {...methods}>
      <DeleteClientDialogPresentation
        onClose={handleClose}
        onSubmit={handleSubmit}
        name={name}
        partnerBranchName={partnerBranchName}
        contactPersonName={contactPersonName}
        contractPlanName={contractPlanName}
        userCount={userCount}
        hasPartnerBranch={hasPartnerBranch}
        isConfirmDisabled={!isSubmitEnabled}
      />
    </FormProvider>
  );
};
